import * as sonbp from "sonbp";
import * as ifbase from "../base";
import * as tool from '../tool'
import { poscaSelector } from "./poscaSelector";
import { poscaSelectorWithExchange } from "./poscaSelectorWithExchange";


/**
* ポスカ用セレクター（SP版画像レイヤー用）
* @summary 描画オブジェクトの選択操作を行います。
* @summary 画像枠間での画像入替えができます。
* @summary タッチ操作の場合マウスとタッチ両イベント発火するため、タッチイベントのみ反応するようにしています。
*/
export class poscaSelectorWithExchangeSP extends poscaSelectorWithExchange {

	// -----------------------------------------------
	// Properties
	// -----------------------------------------------

	// -----------------------
	// イベント受付機能 関数
	// -----------------------

	/**
	 * マウスダウン処理
	 * @override
	 */
	protected gevMousedown(e: MouseEvent, vp: sonbp.type.localViewPosition): sonbp.type.listerResult {
		console.log("gevMousedown");
		return super.gevMousedown(e, vp);
	}

	/**
	 * マウスムーブ処理
	 * @override
	 */
	protected gevMousemove(e: MouseEvent, vp: sonbp.type.localViewPosition): sonbp.type.listerResult {
		console.log("gevMousemove");
		return new sonbp.type.listerResult();
	}

	/**
	 * マウスアップ処理
	 * @override
	 */
	protected gevMouseup(e: MouseEvent, vp: sonbp.type.localViewPosition): sonbp.type.listerResult {
		console.log("gevMouseup");
		return super.gevMouseup(e, vp);
	}

	/**
	 * タッチ処理
	 * @override
	 */
	protected gevTouchstart(e: TouchEvent, vp: sonbp.type.localViewPosition): sonbp.type.listerResult {
		console.log("gevTouchstart");

		let result = super.gevTouchstart(e, vp);

		//D&D可否の判定（ボタン活性状態見る必要あるため、直接Vueで判断する）
		if (this._ifdto.vue.$data.Show.EditImageMenu == false) {
			return result;
		}

		let nextObject = this.getHitObject(vp.docPt, true);
		if (nextObject) {

			// ドラッグ開始準備
			this.dragReady(nextObject);
		}

		return result;
	}

	/**
	 * タッチムーブ処理
	 * 画像枠間入替えのON/OFFも兼ねる
	 * @override
	 */
	protected gevTouchmove(e: TouchEvent, vp: sonbp.type.localViewPosition): sonbp.type.listerResult {
		console.log("gevTouchmove");

		let result = super.gevTouchmove(e, vp);

		this._lastPt = vp;
		this._dstBox = null;

		// ドラッグ開始
		let dstObject = this.getHitObject(vp.docPt, true);
		this.dragStart(dstObject);

		result.isDrawEditCanvas = true;
		return result;
	}

	/**
	 * タッチエンド処理
	 * @override
	 */
	protected gevTouchend(e: TouchEvent, vp: sonbp.type.localViewPosition): sonbp.type.listerResult {
		console.log("gevTouchend");

		var result = super.gevTouchend(e, vp);

		if (this._srcBox == null) return result;

		let that = this;

		// ドロップ成立なら画像入替え
		let nextObject = this.getHitObject(vp.docPt, true);
		this.drop(nextObject, (res: boolean) => {
			if (res) {
				//選択解除
				that._ifdto.activeSelector.clear();
			} else {
				that._ifdto.callbackOnApiError(e);
			}
		});

		result.isDrawEditCanvas = true;
		return result;
	}

	/**
	 * タッチキャンセル処理
	 * @override
	 */
	protected gevTouchcancel(e: TouchEvent, vp: sonbp.type.localViewPosition): sonbp.type.listerResult {
		console.log("gevTouchcancel");

		var result = super.gevTouchend(e, vp);
		result.isPrevent = true;

		if (this._srcBox != null) {
			console.debug("★★ドラッグ中のタッチイベント中断！");
			this.dragInit();
		}

		return result;
	}

}